<div class="section-header" *ngIf="sectionsContent?.title">
    <div class="title">
        {{sectionsContent?.title}}
    </div>
</div>

<div class="pr-table" *ngIf="sectionType && model && sectionModel " [ngClass]="{'warranty': sectionType === 'WARRANTY_NOTES'}">
    <div class="pr-row" *ngFor="let field  of sectionsContent?.fields">
        <div class="label-cell">{{field.label}}</div>
        <div class="field-content">{{ getFieldText(field) }}</div>
    </div>
</div>


<!--<div>{{sectionModel | json}}</div>-->


